import type { GetServerSidePropsContext } from "next/types";

import Bugsnag from "@bugsnag/js";

import Page from "components/WatchlistsPage";
import type { NextPageWithLayout } from "pages/_app";

const DashboardPage: NextPageWithLayout = () => {
  return <Page />;
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  try {
    return {
      props: {
        fallback: {},
      },
    };
  } catch (error: any) {
    console.error(
      "[slug].tsx ~ getServerSideProps dashboard Page ~ error",
      error
    );
    Bugsnag.notify(error);
    return {
      props: {
        fallback: {},
      },
    };
  }
}

export default DashboardPage;
